<template>
	<div class="page">
		<div class="screenLine">
			<div class="screenLineL">
				<el-input v-model="keyword" @keyup.enter.native="changeSearch" placeholder="输入关键字" style="width:140px;margin-right: 16px;"></el-input>
				<el-button type="warning" @click="reset">重置</el-button>
			</div>
			<div class="screenLineR">
				<!-- <el-button type="warning" >新建精华文章</el-button> -->
			</div>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" height="100%">
				<el-table-column prop="no" label="序号" width="50">
					<template slot-scope="scope">
						{{scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column label="门店名称" >
					<template slot-scope="scope">
						{{scope.row.shopName}}
					</template>
				</el-table-column>
				<el-table-column label="营业时间" width="130">
					<template slot-scope="scope" >
						{{scope.row.workTime}}
					</template>
				</el-table-column>
				<el-table-column label="门店电话" >
					<template slot-scope="scope">
						{{scope.row.tel}}
					</template>
				</el-table-column>
				<el-table-column label="门店地址" width="300">
					<template slot-scope="scope" >
						{{scope.row.address}}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="80">
					<template slot-scope="scope">
						{{scope.row.status===0?'禁用':''}}
						{{scope.row.status===1?'启用':''}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="170">
					<template slot-scope="scope">
						<el-button @click="curRow=scope.row;drawerSee_state=true" type="text">查看</el-button>
						<el-button @click="curRow=scope.row;drawerEdit_state=true" type="text">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
		<div v-if="drawerSee_state">
			<drawerSee :id="curRow.shopId" @submit="drawerSee_state=false"></drawerSee>
		</div>
		<div v-if="drawerEdit_state">
			<drawerEdit :id="curRow.shopId" @submit="submit_drawerEdit"></drawerEdit>
		</div>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	import drawerSee from "./drawer_storeSee.vue"
	import drawerEdit from "./drawer_storeEdit.vue"
	export default {
		components:{page,drawerSee,drawerEdit},
		data() {
			return {
				keyword:'', //关键字
				
				// 列表
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				
				drawerSee_state:false,
				curRow:{},
				drawerEdit_state:false,
			}
		},
		computed:{
			
		},
		created(){
			
		},
		mounted(){
			this.getTableData()
		},
		methods:{
			see(row){
				this.$router.push({path:"/shop/storeSee",query:{id:row.shopId}})
			},
			submit_drawerEdit(obj){
				this.drawerEdit_state = false;
				if(obj.type==='success'){
					this.getTableData()
				}
			},
			// 列表
			changeSearch(){
				this.page.page = 1;
				this.getTableData()
			},
			reset(){
				this.keyword = ''
				
				this.page.page = 1;
				this.getTableData()
			},
			changePage(num){
				this.page.page = num;
				this.getTableData()
			},
			getTableData(){
				let params = {
					companyId:'5e9412e0b2bfbc030160bdd5',
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_baseData+'/api/CompanyInfo/shop/detail/list', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.tableData = res.data||[];
						this.page.total = this.tableData.length;
					}
				})
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.page{
		padding:16px 16px 65px 16px;height: 100%;box-sizing: border-box;position: relative;
		.screenLine{
			display: flex;justify-content: space-between;
			.screenLineL{
				
			}
			.screenLineR{
				
			}
		}
		.tableBox{
			padding:16px;border-radius: 8px;background-color: #fff;box-sizing: border-box;margin-top:16px;height: calc(100% - 56px);
		}
		
		.pagePosi{
			position: absolute;bottom:0;left:16px;right:16px;text-align:right;background-color: #fff;padding:0 10px;border-radius: 8px 8px 0 0;
		}
	}
</style>
